<!--
 * @Author: gzm
 * @Date: 2021-06-21 20:46:31
 * @Description:代码树
-->
<template>
  <div>
      <el-input placeholder="输入关键字进行过滤"  v-model="filterText">
      </el-input>
      <el-tree :data="treeData" node-key="id" ref="Tree" :filter-node-method="filterNode" highlight-current
               :default-expanded-keys="expandKeys" @node-click='handleNodeClick' :expand-on-click-node="false" :props="defaultProps"
               @node-expand="handleNodeExpand" @node-collapse="handleNodeCollapse" draggable :allow-drop="allowDrop"
               @node-drop='nodeDrop'>
          <span class="custom-tree-node" slot-scope="{ node, data }">
              <span class="tree-node-value if-story" v-if="node.label!=''">
                  <span>{{node.label}}</span>
              </span>
              <span class="opreate-btns" v-show="currentNodeId==data.id">
                  <el-popover placement="right" width="320" popper-class="feature-tree-popover"
                              :disabled="currentNodeId!=data.id" v-model="nodePopoverVisible">
                      <el-form v-if="nodePopoverVisible" :model="addNodeForm" :rules="rules" ref="ruleForm" @click.stop.native
                               @submit.native.prevent>
                          <el-form-item label="代码" label-width="80px" prop="name" >
                              <el-input v-model="addNodeForm.name" autocomplete="off" :disabled="codeValuedisabled"></el-input>
                          </el-form-item>
                          <el-form-item label="含义" label-width="80px" prop="description">
                              <el-input v-model="addNodeForm.description" autocomplete="off"></el-input>
                          </el-form-item>
                          <el-form-item label="业务代码" label-width="80px" prop="otherCode">
                              <el-input v-model="addNodeForm.otherCode" autocomplete="off"></el-input>
                          </el-form-item>
                      </el-form>
                      <div style="text-align: right; margin: 0">
                          <el-button type="primary" size="mini" @click="handleFormAddClick('添加')">确定</el-button>
                          <el-button size="mini" type="info" @click="nodePopoverVisible = false">取消
                          </el-button>
                      </div>
                      <el-button slot="reference" type="text" size="mini" @click.stop="() => appendNode(data,node)" :disabled="editDisabled&&data.status!=1"
                                 v-show="data.id!=1">
                          <img src="../../assets/images/add01.png" title="添加同级节点" alt />
                      </el-button>
                  </el-popover>
                  <el-popover placement="right" width="320" popper-class="feature-tree-popover"
                              :disabled="currentNodeId!=data.id" v-model="childNodePopoverVisible">
                      <el-form v-if="childNodePopoverVisible" :model="addNodeForm" :rules="rules" ref="ruleForm"
                               @click.stop.native @submit.native.prevent>
                          <el-form-item label="代码" label-width="80px" prop="name">
                              <el-input v-model="addNodeForm.name" autocomplete="off" :disabled="codeValuedisabled"></el-input>
                          </el-form-item>
                          <el-form-item label="含义" label-width="80px" prop="description">
                              <el-input v-model="addNodeForm.description" autocomplete="off"></el-input>
                          </el-form-item>
                          <el-form-item label="业务代码" label-width="80px" prop="otherCode">
                              <el-input v-model="addNodeForm.otherCode" autocomplete="off"></el-input>
                          </el-form-item>
                      </el-form>
                      <div style="text-align: right; margin: 0">
                          <el-button type="primary" size="mini" @click="handleFormAddClick('添加')">确定</el-button>
                          <el-button size="mini" type="info" @click="childNodePopoverVisible = false">取消
                          </el-button>
                      </div>
                      <el-button slot="reference" type="text" size="mini" @click.stop="() => appendChild(data,node)" :disabled="editDisabled&&data.status!=1">
                          <img src="../../assets/images/add02.png" title="添加子节点" alt />
                      </el-button>
                  </el-popover>
                  <el-popover placement="right" width="320" popper-class="feature-tree-popover"
                              :disabled="currentNodeId!=data.id" v-model="editPopoverVisible">
                      <el-form v-if="editPopoverVisible" :model="addNodeForm" :rules="rules" ref="ruleForm" @click.stop.native
                               @submit.native.prevent>
                               <el-form-item label="代码" label-width="80px" prop="name">
                              <el-input v-model="addNodeForm.name" autocomplete="off" disabled></el-input>
                          </el-form-item>
                          <el-form-item label="含义" label-width="80px" prop="description">
                              <el-input v-model="addNodeForm.description" autocomplete="off"></el-input>
                          </el-form-item>
                          <el-form-item label="业务代码" label-width="80px" prop="otherCode">
                              <el-input v-model="addNodeForm.otherCode" autocomplete="off"></el-input>
                          </el-form-item>
                      </el-form>
                      <div style="text-align: right; margin: 0">
                          <el-button type="primary" size="mini" @click="handleFormAddClick('修改')">确定</el-button>
                          <el-button size="mini" type="info" @click="editPopoverVisible = false">取消
                          </el-button>
                      </div>
                      <el-button slot="reference" type="text" size="mini" @click.stop="() => editNode(data, node)" :disabled="editDisabled&&data.status!=1">
                          <img src="../../assets/images/xiugai.png" title="编辑节点名称" alt />
                      </el-button>
                  </el-popover>
                  <el-button type="text" size="mini" :disabled="editDisabled">
                      <img src="../../assets/images/forbid.png" @click.stop="remove(data, node)" title="禁用/启用节点" alt />
                  </el-button>
              </span>
          </span>
      </el-tree>
  </div>
</template>

<script>
export default {
  name: '',
  components: {

  },
  data () {
      return {
          codeValuedisabled:true,//弹框中的代码字段是否可编辑
          editDisabled:true,//是否可操作代码树
          filterText: '',
          treeData: [
              {
                  id: 1,
                  value: '请在下方按顺序输入代码值',
                  codes: [

                  ]
              }
          ],
          defaultProps: {
              children: 'codes',
              label: 'value'
          },
          addNodeForm: {
              name:'',
              code: '',
              description:'',
              otherCode:''
          },
          currentNodeId: '',
          currentNode: {},
          currentNodeData: {},
          isNodeEdit: false,
          isAddChild: false,
          nodePopoverVisible: false,
          childNodePopoverVisible: false,
          editPopoverVisible: false,
          rules: {
              name: [
                { validator: function (rule, value, callback) {
                  if (!/^[A-Za-z0-9\-\_]{1,32}$/.test(value)) {
                      return callback(new Error('请输入至多32位的合法字符(字母、数字、-、_)'));
                  } else {
                      callback();
                  }}}
                ]
          },
          expandKeys: [1],
      };
  },
  props: ['columnData'],
  mounted () {
  },
  watch: {
      filterText (val) {
          this.$refs.Tree.filter(val);
      },
      treeData: {
          deep: true,
          handler (val) {
              // val.isSaved = false;
              this.$emit('input', val);
              if (val[0].codes.length) {
                  this.$emit('fieldDraggable', false);
              } else {
                  this.$emit('fieldDraggable', true);
              }
          }
      },
      currentNodeId () {
          this.nodePopoverVisible = false;
          this.childNodePopoverVisible = false;
          this.editPopoverVisible = false;
      }
  },
  methods: {
      /**
       * @author: liuc
       * @description: 节点拖拽
       * @param {}:
       */
      allowDrop (draggingNode, dropNode, type) {
          if (draggingNode.level === dropNode.level) {
              if (draggingNode.parent.id === dropNode.parent.id) {
                  // 向上拖拽 || 向下拖拽
                  return type === 'prev' || type === 'next';
              }
          } else {
              // 不同级进行处理
              return false;
          }
      },
      /**
       * @author: liuc
       * @description: 移动结果请求接口保存当前位置
       * @param {}:
       */
      async nodeDrop (draggingNode, endNode, dropType, event) {
          let target = '';
          if (dropType == 'before') {
              target = endNode.data.id;
          } else if (dropType == 'after') {
              var nextIndex = '';
              if (endNode.parent.level == 0) {
                  endNode.parent.data.forEach((item, index) => {
                      if (item.id == draggingNode.data.id) {
                          nextIndex = index;
                      }
                  });
                  if (nextIndex < endNode.parent.data.length - 1) {
                      target = endNode.parent.data[nextIndex + 1].id;
                  } else {
                      target = '';
                  }
              } else {
                  endNode.parent.data.codes.forEach((item, index) => {
                      if (item.id == draggingNode.data.id) {
                          nextIndex = index;
                      }
                  });
                  if (nextIndex < endNode.parent.data.codes.length - 1) {
                      target = endNode.parent.data.codes[nextIndex - 1].id;
                  } else {
                      target = endNode.parent.data.codes[nextIndex - 1].id;
                  }
              }
          }
          let param = {
              id: draggingNode.data.id,
              target,
              // versionType: 1,
              // year: this.year
          };
          await this.$api.CodeManagement.codeMove(param);
      },
      /**
       * @author: liuc
       * @description: 多级代码搜索
       * @param {}: 值为过滤函数
       */
      filterNode (value, data) {
          if (!value) return true;
          if (data.value) {
              return data.value.indexOf(value) !== -1;
          }
      },
      /**
       * @author: jingyh
       * @description: 保存的确定
       * @param {type}
       */
      handleFormAddClick (type) {
          this.$refs['ruleForm'].validate(async (valid) => {
              if (valid) {
                  // 插入得父级id和插入级别
                  var insertFeaturesId = '';
                  // 判断是编辑还是新增
                  if (this.isNodeEdit) {
                      this.currentNodeData.value = this.addNodeForm.description;
                      // this.$parent.$parent.handleCodeSaveClick(true);
                      // if (this.$parent.$parent.columnData.columnType == 5) { this.$parent.$parent.handleCodeSaveClick(true); }
                      this.currentNodeId = '';
                  } else {
                      // 判断是添加几级节点 最多5级
                      // let count = 1;
                      // var currentData = this.currentNode;
                      // var data = currentData.parent;
                      // for (let index = 0; index < count; index++) {
                      //     if (data.parent) {
                      //         count++;
                      //         data = data.parent;
                      //     } else {
                      //         break;
                      //     }
                      // }
                      // 判断是新增子节点还是同级节点
                      if (this.isAddChild) {
                          if (!this.currentNodeData.codes) {
                              this.$set(this.currentNodeData, 'codes', []);
                          }
                          // if (count > 4) {
                          //     this.$message.warning('最多添加五级节点');
                          // } else {
                          insertFeaturesId = this.currentNodeId;
                          // this.addNewNode(this.addNodeForm.name, insertFeaturesId, this.currentNode);
                          // }
                      } else {
                          // 定义是否为插入的功能
                          let flag = true;
                          // 判断是否一级功能
                          if (this.currentNode.level == 1) {
                              insertFeaturesId = '';
                              this.currentNode.parent.data.forEach((item, index) => {
                                  if (this.currentNode.parent.data[this.currentNode.parent.data.length - 1].id == this.currentNodeId) {
                                      flag = false;
                                  }
                              });
                          } else {
                              insertFeaturesId = this.currentNode.parent.data.id;
                              this.currentNode.parent.data.codes.forEach((item, index) => {
                                  if (this.currentNode.parent.data.codes[this.currentNode.parent.data.codes.length - 1].id == this.currentNodeId) {
                                      flag = false;
                                  }
                              });
                          }
                          // this.addNewNode(this.addNodeForm.name, insertFeaturesId, this.currentNode);
                      }
                  }

                  let param = {
                      currentNode: this.currentNode,
                      currentNodeData: this.currentNodeData,
                      codeValue: this.addNodeForm.name,
                      description:this.addNodeForm.description,
                      otherCode:this.addNodeForm.otherCode,
                      type: type
                  };
                  this.$emit('getCodeInfo', param, this.currentNodeData, this.isAddChild);
                  this.isNodeEdit = false;
                  this.nodePopoverVisible = false;
                  this.childNodePopoverVisible = false;
                  this.editPopoverVisible = false;
                  // this.treeData.isSaved = false;
                  // this.addNodeForm.name = ''
              }
          });
      },
      async addNewNode (title, featureId, isInsert) {
          var arr = isInsert.level == 1 ? isInsert.parent.data : isInsert.parent.data.codes;
          let currentIndex;
          var _this = this;
          arr.forEach((item, index) => {
              if (item.id == _this.currentNodeId) {
                  currentIndex = index;
              }
          });
          // this.$message.success('新增成功');
          const newNode = {
              value: title,
              codes: [],
              id: featureId
          };
          if (this.isAddChild) {
              isInsert.data.codes.push(newNode);
          } else {
              isInsert.level == 1 ? isInsert.parent.data.splice(currentIndex + 1, 0, newNode)
              : isInsert.parent.data.codes.splice(currentIndex + 1, 0, newNode);
          }
          // this.currentNodeData = newNode;
          this.$nextTick(() => {
              this.$refs.Tree.setCurrentKey(this.currentNodeId);
              isInsert = this.$refs.Tree.getNode(this.currentNodeId);
          });
          this.currentNodeId = '';
          if (this.$parent.$parent.columnData.columnType == 5) { this.$parent.$parent.handleCodeSaveClick(true); }
      },
      /**
       * @author: jingyh
       * @description: 添加同级节点图标点击
       * @param {type}
       */
      appendNode (data, node) {
          this.addNodeForm.description = ''
          this.addNodeForm.name = '';
          this.addNodeForm.otherCode = ''
          this.isAddChild = false;
          // this.dialogFormVisible = true
          this.childNodePopoverVisible = false;
          this.editPopoverVisible = false;
      },
      /**
       * @author: jingyh
       * @description: 添加子节点图标点击
       * @param {type}
       */
      appendChild (data, node) {
          this.addNodeForm.description = ''
          this.addNodeForm.name = '';
          this.addNodeForm.otherCode = ''
          this.isAddChild = true;
          this.currentNode = node;
          this.currentNodeData = data;
          this.nodePopoverVisible = false;
          this.editPopoverVisible = false;
      },
      /**
       * @author: jingyh
       * @description: 编辑节点名称
       * @param {type}
       */
      editNode (data, node) {
          console.log(data)
          this.addNodeForm.description = data.value
          this.addNodeForm.name = data.code;
          this.addNodeForm.otherCode = data.aka
          this.nodePopoverVisible = false;
          this.childNodePopoverVisible = false;
          this.isNodeEdit = true;
      },
      handleNodeClick (data, node) {
          this.currentNodeId = data.id;
          this.currentNode = node;
          this.currentNodeData = data;
      },
      remove (data, node) {
        console.log(data,node);
          if (data.id === 1) {
              return false;
          }
          const h = this.$createElement;
          this.$msgbox({
              title: '',
              message: h('p', null, [
                  h('span', null, '是否禁用本条数据？ ')
              ]),
              showCancelButton: true,
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              cancelButtonClass: 'el-button--primary',
              customClass: 'delete-confirm',
              beforeClose: (action, instance, done) => {
                  done();
              }
          }).then(async action => {
              // const parent = node.parent;
              // const codes = parent.data.codes || parent.data;
              // const index = codes.findIndex(d => d.id === data.id);
              // this.currentNodeId = '';
              let params = {
                  id: data.id,
              };
              await this.$api.CodeManagement.status(data.id);
              this.$emit('show',this.columnData)

              // this.$parent.$parent.handleCodeSaveClick(true);
              // this.treeData.isSaved = false;
          });
      },

      // 树节点展开
      handleNodeExpand (data) {
          // 保存当前展开的节点
          let flag = false;
          this.expandKeys.some(item => {
              if (item === data.id) { // 判断当前节点是否存在， 存在不做处理
                  flag = true;
                  return true;
              }
          });
          if (!flag) { // 不存在则存到数组里
              this.expandKeys.push(data.id);
          }
      },
      // 树节点关闭
      handleNodeCollapse (data) {
          this.expandKeys.some((item, i) => {
              if (item === data.id) {
                  // 删除关闭节点
                  this.expandKeys.splice(i, 1);
              }
          });
      }
  }
};
</script>

<style scoped lang="scss">
.el-tree {
  .opreate-btns {
      margin-left: 12px;

  }
  .custom-tree-node {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding-right: 8px;
  }
  .el-tree--highlight-current
      /deep/
      .el-tree-node.is-current
      > .el-tree-node__content {
      background-color: rgba(67, 153, 211, 1) !important;
      .tree-node-value {
          color: #fff !important;
      }
  }
}
.el-form-item {
        margin-bottom: 36px;
      }
</style>



// WEBPACK FOOTER //
// ./src/components/Comencapsulation/cs-codeTree.vue